import { render } from "./ModelListView.vue?vue&type=template&id=4cb1e3b4&scoped=true"
import script from "./ModelListView.vue?vue&type=script&lang=js"
export * from "./ModelListView.vue?vue&type=script&lang=js"

import "./ModelListView.vue?vue&type=style&index=0&id=4cb1e3b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cb1e3b4"]])

export default __exports__